module.exports = __webpack_public_path__ + "img/left_arrow_circle.svg";